enum ActionType {
    DISPLAY_DELETE_MODAL = '[DELETE_CALL_HOME_REQUEST] DISPLAY DELETE MODAL',
    CLOSE_DELETE_MODAL = '[DELETE_CALL_HOME_REQUEST] CLOSE DELETE MODAL',
    DELETE_CALL_HOME_REQUEST = '[DELETE_CALL_HOME_REQUEST] DELETE CALL HOME REQUEST',
    CALL_HOME_REQUEST_DELETED = '[DELETE_CALL_HOME_REQUEST] CALL HOME REQUEST DELETED',
    SET_ERROR = '[DELETE_CALL_HOME_REQUEST] SET ERROR',
}

export default ActionType
